import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import Address from "../../searchresults/Address";
import { getPersonAddressDetails } from "./PersonAddressDetails";
import SimpleAccordionContent from "../../common/SimpleAccordionContent";

class NeighborsHistorical extends Component {
  state = {
    rows: [],
    savedResultID: "",
    internalID: "",
  };

  componentWillReceiveProps(nextProps) {
    const { internalID, savedResultID } = nextProps.additionalData;
    if (
      this.state.internalID !== internalID ||
      this.state.savedResultID !== savedResultID
    ) {
      this.setState({ internalID, savedResultID });
      this.loadData(nextProps);
    }
  }

  handleClick = () => {
    if (this.state.activeIndex === 0) {
      this.setState({ activeIndex: -1 });
    } else {
      this.setState({ activeIndex: 0 });
    }
  };

  loadData = (props) => {
    let rows = [];
    let recCount = 0;
    if (props.reportData) {
      const addressList = _.get(
        props.reportData,
        "personReport.compReportResponse[0].individual[0].historicalNeighbors[0].neighborhood"
      );

      _.forEach(addressList, (address, addIndex) => {
        rows.push(
          <Table.Row
            key={`row_neigh_${addIndex}`}
            className="report-sub-section-header"
          >
            <Table.Cell width={3}> Neighborhood of: </Table.Cell>
            <Table.Cell width={8}>
              <Address
                addressNode={address.subjectAddress[0].address[0]}
                {...props}
              />
            </Table.Cell>
            <Table.Cell width={5} />
          </Table.Row>
        );
        const phoneInfos = _.get(
          address,
          "neighborAddresses[0].neighborAddress"
        );
        if (phoneInfos !== undefined) {
          recCount += phoneInfos.length;
          rows = rows.concat(
            getPersonAddressDetails(props, phoneInfos, addIndex)
          );
        }
      });
    } else {
      rows.push(
        <Table.Row key={`no_recs_row`}>
          <Table.Cell colSpan={2}>No Records found</Table.Cell>
        </Table.Row>
      );
    }
    this.setState({ rows });
    props.updateItemCountBySection(props.sectionName, recCount);
  };

  render() {
    return (
      <SimpleAccordionContent
        {...this.props}
        name={"Neighbors Historical"}
        rows={this.state.rows}
      />
    );
  }
}

export default NeighborsHistorical;



// WEBPACK FOOTER //
// ./src/components/reports/Platinum/NeighborsHistorical.js